import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ActivateOn = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.6475 4.35254C11.7352 4.09083 12.0185 3.9495 12.2803 4.03711C15.1195 4.98949 17.1659 7.67167 17.166 10.833C17.166 14.7909 13.9579 17.9998 10 18C6.04211 17.9998 2.83301 14.7909 2.83301 10.833C2.83316 7.67172 4.88056 4.98954 7.71973 4.03711C7.98138 3.9496 8.26474 4.09094 8.35254 4.35254C8.44017 4.61427 8.29883 4.89757 8.03711 4.98535C5.59316 5.8053 3.83316 8.11437 3.83301 10.833C3.83301 14.2387 6.59439 16.9998 10 17C13.4056 16.9998 16.166 14.2387 16.166 10.833C16.1659 8.1142 14.4061 5.80516 11.9619 4.98535C11.7004 4.8974 11.5598 4.61416 11.6475 4.35254ZM10 2C10.276 2.00018 10.5 2.22397 10.5 2.5V10C10.5 10.276 10.276 10.4998 10 10.5C9.72401 10.4998 9.5 10.276 9.5 10V2.5C9.5 2.22397 9.72401 2.00018 10 2Z"
		/>
	</SvgIcon>
);
